import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { Container } from 'react-bootstrap';
import Router from 'next/router';
import PropTypes from 'prop-types';
import Cookies from 'lib/js-cookie';
import useLang from '../../../context/LanguageContext';
import NewsletterPreview from '../../../components/Newsletter/NewsletterPreview';
import { getCampaign, updateEditionViewCount } from '../../../apis/newsletter';
import PublicTopNavigation from '../../../components/Navigation/PublicTopNavigation';
import routes from '../../../utils/routes';

const NewsletterDetail = (props) => {
  const { newsletterData, slug, host, isShare } = props;
  const { lang } = useLang();
  const publicPageHost = host || window?.location?.host;
  const [redirectUrl, setRedirectUrl] = useState(null);

  useEffect(() => {
    if (window !== undefined) {
      const temp = window?.location?.href;
      setRedirectUrl(temp);
    }
  }, []);

  useEffect(() => {
    if (Cookies.get('isPreview')) {
      if (
        process.env.NEXT_PUBLIC_APP_FRONTEND_URL === 'http://localhost:3000'
      ) {
        Cookies.remove('isPreview', { path: '/' });
      } else {
        Cookies.remove('isPreview', { path: '/', domain: '.mumbler.io' });
      }
    } else {
      trackEditionViews();
    }
  }, []);
  const trackEditionViews = async () => {
    const payload = {
      campaign_slug: slug,
    };
    const response = await updateEditionViewCount(payload);
    if (response?.status === 200) {
    }
  };

  return (
    <div className="page nosidebar">
      <Head>
        <title>NewsLetter | Mumbler</title>
        {/*<link rel="icon" href="/favicon.png" />*/}
        <link rel="canonical" href={`${newsletterData?.domain_redirect_url}`} />
        <meta name="description" content={newsletterData?.seo_description} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={newsletterData?.seo_title} />
        <meta
          property="og:description"
          name="description"
          content={newsletterData?.seo_description}
        />
        <meta
          property="og:url"
          content={`${newsletterData?.domain_redirect_url}`}
        />
        <meta
          property="og:image"
          content={newsletterData?.social_share_image}
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={newsletterData?.seo_title} />
        <meta
          name="twitter:description"
          content={newsletterData?.seo_description}
        />
        <meta
          name="twitter:url"
          content={`${newsletterData?.domain_redirect_url}`}
        />
        <meta
          name="twitter:image"
          content={newsletterData?.social_share_image}
        />
      </Head>
      {/* <Header lang={lang} title="Newsletter Detail" /> */}
      {/* <Sidebar lang={lang} /> */}
      <main className="main m-0">
        <Container className="full mobile-full" fluid>
          <PublicTopNavigation showLine lang={lang} redirectUrl={redirectUrl} />
          <NewsletterPreview
            newsletterData={newsletterData}
            host={publicPageHost}
            isShare={!!isShare}
          />
        </Container>
      </main>
    </div>
  );
};

NewsletterDetail.getInitialProps = async (context) => {
  const { query, res } = context;
  const newsletterSlug = query['newsletter-id'];
  const host = context?.req?.headers?.host;

  const response = await getCampaign(newsletterSlug);
  if (response?.status === 200) {
    return {
      newsletterData: response?.data,
      slug: newsletterSlug,
      host,
      isShare: query.share,
    };
  }
  if (res) {
    res.writeHead(301, {
      Location: routes.error404,
    });
    res.end();
  } else {
    await Router.push(routes.error404);
  }

  return {};
};

NewsletterDetail.propTypes = {
  newsletterData: PropTypes.object,
  slug: PropTypes.string,
  host: PropTypes.string,
  isShare: PropTypes.bool,
};

export default NewsletterDetail;
